import request from '@/helpers/request'
import Vue from 'vue'

export default {
  GET_TICKETS({ commit }, params) {
    return new Promise((resolve, reject) => {
      request('GET', `${Vue.config.server}/api/crm/tickets`, { params })
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  GET_TICKET({ commit }, id) {
    return new Promise((resolve, reject) => {
      request('GET', `${Vue.config.server}/api/crm/tickets/${id}`)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  DELETE_TICKET({ commit }, id) {
    return new Promise((resolve, reject) => {
      request('DELETE', `${Vue.config.server}/api/crm/tickets/${id}`)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  GET_TICKETS_GROUP({ commit }) {
    return new Promise((resolve, reject) => {
      request('GET', `${Vue.config.server}/api/crm/tickets/groups`, {
        params: {
          with: 'members.member',
          orderBy: 'name',
          sortedBy: 'asc',
        },
      })
        .then(res => {
          commit('SET_TICKET_GROUP', res.data.data.items)
          resolve(res.data.data.items)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  GET_TICKET_GROUP({ commit }, id) {
    return new Promise((resolve, reject) => {
      request('GET', `${Vue.config.server}/api/crm/tickets/groups/${id}`)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  ADD_TICKETS_GROUP({ commit }, data) {
    return new Promise((resolve, reject) => {
      request('POST', `${Vue.config.server}/api/crm/tickets/groups`, { data }, true)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  UPDATE_TICKETS_GROUP({ commit }, payload) {
    return new Promise((resolve, reject) => {
      request('PUT', `${Vue.config.server}/api/crm/tickets/groups/${payload.id}`, { data: payload.data }, true)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  DELETE_TICKETS_GROUP({ commit }, id) {
    return new Promise((resolve, reject) => {
      request('DELETE', `${Vue.config.server}/api/crm/tickets/groups/${id}`)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  ADD_TICKET({ commit }, data) {
    return new Promise((resolve, reject) => {
      request('POST', `${Vue.config.server}/api/crm/tickets`, {
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Content-Disposition': 'x-www-form-urlencoded',
        },
      })
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  UPDATE_TICKET({ commit }, payload) {
    return new Promise((resolve, reject) => {
      request('PUT', `${Vue.config.server}/api/crm/tickets/${payload.id}`, { data: payload.data }, true)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  SEND_MESSAGE_TICKET({ commit }, payload) {
    return new Promise((resolve, reject) => {
      request('POST', `${Vue.config.server}/api/crm/tickets/${payload.id}`, {
        data: payload.data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Content-Disposition': 'x-www-form-urlencoded',
        },
      })
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  GET_TICKET_GROUP_MEMBERS({ commit }, id) {
    return new Promise((resolve, reject) => {
      request('GET', `${Vue.config.server}/api/crm/tickets/groups/${id}/members`)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  ADD_TICKET_GROUP_MEMBER({ commit }, payload) {
    return new Promise((resolve, reject) => {
      request('POST', `${Vue.config.server}/api/crm/tickets/groups/${payload.id}/members`, { data: payload.data }, true)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  DELETE_TICKET_GROUP_MEMBER({ commit }, payload) {
    return new Promise((resolve, reject) => {
      request(
        'DELETE',
        `${Vue.config.server}/api/crm/tickets/groups/${payload.group_id}/members/${payload.member_type}/${payload.employer_id}`,
      )
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  UPDATE_TICKET_GROUP_MEMBER({ commit }, payload) {
    return new Promise((resolve, reject) => {
      request(
        'PUT',
        `${Vue.config.server}/api/crm/tickets/groups/${payload.group_id}/members/${payload.member_id}`,
        { data: payload.data },
        true,
      )
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}
